<template>
  <div :class="eligible ? 'green' : 'red'" class="red lighten-5 pa-5 rounded-xl text-center">
    <h3
      class="font-weight-bold"
    >{{ !eligible ? 'Non éligible à la remise' : 'Éligible à la remise !' }}</h3>
    <div class="montant">{{ montant }}€</div>
    <div v-if="eligible">
      <v-btn color="success" class="ma-2" @click="remiseFaite" rounded>
        <v-icon class="mr-4">mdi-check</v-icon>Remise faite
      </v-btn>
      <v-btn color="warning" class="ma-2 lighten-1" @click="showRemisePartielle = true" rounded>
        <v-icon class="mr-4">mdi-circle-half-full</v-icon>Remise partielle
      </v-btn>
    </div>
    <div v-else class="sous-montant">Somme accumulée</div>
    <div
      v-if="report > 0"
      class="sous-montant mt-0"
      style="font-size:0.9rem"
    >Dont somme reportée : {{ report / 100 }}€</div>
    <v-dialog v-model="showRemisePartielle" persistent max-width="700">
      <v-card>
        <v-card-title class="headline">Somme à déduire</v-card-title>
        <v-card-text>
          <v-alert type="error" v-if="erreur != ''">{{ erreur }}</v-alert>
          <v-text-field
            label="Montant à déduire de la remise."
            v-model="sommeADeduire"
            type="number"
            step="0.01"
            filled
            rounded
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="showRemisePartielle = false">Annuler</v-btn>
          <v-btn color="green darken-1" :loading="loading" @click="saveRemisePartielle" dark>Valider</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { db } from "@/firebase";

  export default {
    props: {
      eligible: Boolean,
      montant: Number,
      report: Number,
    },
    data: () => ({
      sommeADeduire: 0,
      showRemisePartielle: false,
      loading: false,
      erreur: "",
    }),
    methods: {
      async remiseFaite() {
        const id = this.$route.params.id;
        await db.doc("clients/" + id).update({ eligible: false, report: 0 });
      },
      async saveRemisePartielle() {
        this.erreur = "";
        if (this.montant < this.sommeADeduire) {
          this.erreur =
            "La somme à déduire doit être inférieure au montant de la réduction.";
          return;
        }
        const id = this.$route.params.id;
        const report = Math.round(this.montant * 100 - this.sommeADeduire * 100);
        this.loading = true;
        await db.doc("clients/" + id).update({ eligible: false, report: report });
        this.showRemisePartielle = false;
        this.sommeADeduire = 0;
        this.loading = false;
      },
    },
  };
</script>

<style>
  .montant {
    font-size: 55px;
    font-weight: 600;
  }
  .sous-montant {
    font-size: 18px;
    font-weight: 200;
    margin-top: -15px;
  }
</style>
